export default __webpack_public_path__ + "static/media/Grid3.1.e758b51a.jpg";